export function getUniverseForumsPath(universeSlug) {
  if (!universeSlug || universeSlug === 'portal') {
    return '/';
  }

  return `/univers/${universeSlug}`;
}

export function getElseworldForumsPath(universeSlug, elseworldSlug) {
  if (!universeSlug || !elseworldSlug) {
    return getUniverseForumsPath(universeSlug);
  }

  return `/univers/${universeSlug}/elseworld/${elseworldSlug}`;
}
